import auth from '@/services/auth'

export default function (router, cookies) {
  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.authByToken)) {
      auth.signInWithToken(to.query.token)
    } else {
      next()
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/nav-guards.js